import { SxProps } from '@mui/material';

export const facetNavigationGridItemSX = (hasFacetEntryValue: boolean): SxProps => ({
	...(hasFacetEntryValue && { width: '100%' }),
});
